import map from 'lodash/map';
import compact from 'lodash/compact';

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_GET_ACCOUNT_CONFIG_FETCH_REQUEST = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            getListSections: true
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_GET_ACCOUNT_CONFIG_FETCH_SUCCESS = (state, action) => {
  const { dataFetch } = action.payload;
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            getListSections: false
          },
          api: {
            ...state.configuration.medicalRecord.sections.api,
            accountMedicalRecordsModel: dataFetch
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_GET_ACCOUNT_CONFIG_FETCH_ERROR = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            getListSections: false
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_GET_LIST_FORM_MODELS_FETCH_REQUEST = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            listFormModels: true
          }
        }
      }
    }
  });
};

export const MODAL_PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_RESET = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          api: {
            ...state.configuration.medicalRecord.sections.api,
            modalOpen: false,
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_GET_LIST_FORM_MODELS_FETCH_SUCCESS = (state, action) => {
  const {listPrivate, listSharing} = action.payload;
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            listFormModels: false
          },
          api: {
            ...state.configuration.medicalRecord.sections.api,
            modalOpen: true,
            listPrivate,
            listSharing
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_GET_LIST_FORM_MODELS_FETCH_ERROR = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            listFormModels: false
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_SET_TRANSFER_SHARING = (state, action) => {
  const {listSharing} = action.payload;
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          api: {
            ...state.configuration.medicalRecord.sections.api,
            listSharing
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_MODAL_CONFIGURATION_MEDICALRECORD_SECTIONS_RESET = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          inputValue: '',
          inputNumberValue: null,
          api: {
            ...state.configuration.medicalRecord.sections.api,
            listSharing: [],
            listPrivate: []
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_SET_TITLE = (state, action) => {
  const {inputValue} = action.payload;
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          inputValue
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_SET_ORDER = (state, action) => {
  const {inputNumberValue} = action.payload;
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          inputNumberValue
        }
      }
    }
  });
};


export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_SAVE_SECTION_ACCOUNT_CONFIG_FETCH_REQUEST = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            saveSection: true
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_SAVE_SECTION_ACCOUNT_CONFIG_FETCH_SUCCESS = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            saveSection: false
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_SAVE_SECTION_ACCOUNT_CONFIG_FETCH_ERROR = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            saveSection: false
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_SET_MEDICALRECORDS_MODEL_SECTION_BY_ID = (state, action) => {
  const {medicalRecordsModelSectionId} = action.payload;
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          api: {
            ...state.configuration.medicalRecord.sections.api,
            accountMedicalRecordsModel: {
              ...state.configuration.medicalRecord.sections.api.accountMedicalRecordsModel,
              medicalRecordsModelSectionId
            }
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_DELETE_SECTION_FETCH_REQUEST = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            removingSection: true
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_DELETE_SECTION_FETCH_ERROR = (state, action) => {
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            removingSection: false
          }
        }
      }
    }
  });
};

export const PERFIL_CONFIGURATION_MEDICALRECORD_SECTIONS_DELETE_SECTION_FETCH_SUCCESS = (state, action) => {
  const {medicalRecordsModelSectionId} = action.payload;
  return ({
    ...state,
    configuration: {
      ...state.configuration,
      medicalRecord: {
        ...state.configuration.medicalRecord,
        sections: {
          ...state.configuration.medicalRecord.sections,
          fetching: {
            ...state.configuration.medicalRecord.sections.fetching,
            removingSection: false
          },
          api: {
            ...state.configuration.medicalRecord.sections.api,
            accountMedicalRecordsModel: {
              ...state.configuration.medicalRecord.sections.api.accountMedicalRecordsModel,
              listSections: compact(map(state.configuration.medicalRecord.sections.api.accountMedicalRecordsModel.listSections, listItem => {
                if(listItem.medicalRecordsModelSectionId !== medicalRecordsModelSectionId) return listItem
              }))
            }
          }
        }
      }
    }
  });
};